import React from 'react';

const Mobile = () => {
    return (
        <svg width={12} height={17.143} viewBox="0 0 12 17.143">
            <path
                d="M6.609 12.249l-.129-.1a.651.651 0 00-.154-.077L6.171 12a.857.857 0 00-.78.231.986.986 0 00-.18.283.857.857 0 001.114 1.123 1.251 1.251 0 00.283-.189.848.848 0 000-1.2zM9.429 0H2.571A2.571 2.571 0 000 2.571v12a2.571 2.571 0 002.571 2.571h6.857A2.571 2.571 0 0012 14.571v-12A2.571 2.571 0 009.429 0zm.857 14.571a.857.857 0 01-.857.857H2.571a.857.857 0 01-.857-.857v-12a.857.857 0 01.857-.857h6.857a.857.857 0 01.857.857z"
                fill="#8f99dc"
            />
        </svg>
    );
};

export default Mobile;
